import { useEffect, useRef, useState } from "react";
import { useDebounce } from "react-use";
import { NodeMap } from "src/types/node.types";
import { generateNodes } from "../helpers/generator.helpers";
import { useNestedTree } from "src/features/tree";
import type { CanvasPositionMap } from "src/features/editor";

export function useGenerator(nodes: NodeMap, positions: CanvasPositionMap) {
  const nestedTree = useNestedTree(positions, nodes);
  const [output, setOutput] = useState<unknown>("");
  const debounceTime = useDebounceTimeAfterFirstReRender();

  useDebounce(
    async () => {
      // TODO: Abort existing promise
      const value = await generateNodes(nestedTree.nodes);
      setOutput(value);
    },
    debounceTime,
    [nestedTree]
  );

  const formattedOutput = output === "" ? "" : JSON.stringify(output, null, 2);
  return formattedOutput;
}

function useDebounceTimeAfterFirstReRender() {
  const renders = useRef(1);
  useEffect(() => void renders.current++);
  return renders.current > 2 ? 500 : 0;
}
